module.exports = __webpack_public_path__ + "static/media/bronze_lock.d054960f.jpg";